module.exports = __webpack_public_path__ + "static/img/xtba123.23f12f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xtba123.jpg
// module id = MyEr
// module chunks = 73